<template>
  <div class="lmp-block clearBoth">
    <g-switch-list1
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :horizontal-type="1"
      :title="d.title"
      :chip="chip"
      :columns="4"
      :list="d.list"></g-switch-list1>

    <g-switch-list2
      :chip="chip"
      class="lmp-vertical"
      v-for="(d, i) in data.vertical"
      :key="'v' + i"
      :vertical-type="1"
      :title="d.title"
      :list="d.list"></g-switch-list2>
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向
  import GSwitchList2 from '../../c_game-switch/switch-list/g_switch-2'; // 纵向

  export default {
    name: "pk10_lmp",
    mixins: [mixin],
    components: {
      GSwitchList1,
      GSwitchList2
    }
  }
</script>

<style scoped lang="stylus">
  .lmp-vertical
    width calc(20% - 5.6px)
    float left
    margin-top 7px

  .lmp-vertical + .lmp-vertical
    margin-left 7px

  .lmp-vertical:nth-of-type(7)
    margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/pk10/lmp.vue